export default __webpack_public_path__ + "static/media/B216.d556e25b.png";